// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class FundingRateMarkupPlan {
    constructor(id) {
        this._dataByInstruments = {};
        this._dataByInstrumentGroup = {};
        this._dataByInstrumentsHasValue = false;
        this._dataByInstrumentGroupHasValue = false;
        this.Id = id;
    }
    GetData(instr) {
        if (instr === null) {
            return null;
        }
        let data = this._dataByInstruments[instr.Id]; // InstrumentId === Id
        if (data) {
            return data;
        }
        data = this._dataByInstrumentGroup[instr.TypeId]; // InstrumentGroupId === TypeId
        if (data) {
            return data;
        }
        return this._defaultData;
    }
    Update(message) {
        this.Name = message.Name;
        this._dataByInstruments = {};
        this._dataByInstrumentGroup = {};
        this._defaultData = null;
        this._dataByInstrumentsHasValue = false;
        this._dataByInstrumentGroupHasValue = false;
        for (let i = 0; i < message.Data.length; i++) {
            this.AddData(message.Data[i]);
        }
    }
    AddData(data) {
        if (data.InstrumentId) {
            this._dataByInstruments[data.InstrumentId] = data;
            this._dataByInstrumentsHasValue = true;
        }
        else if (data.InstrumentGroupId !== null) {
            this._dataByInstrumentGroup[data.InstrumentGroupId] = data;
            this._dataByInstrumentGroupHasValue = true;
        }
        else {
            this._defaultData = data;
        }
    }
}
